<template>
  <v-layout row wrap class="dashboard-buttons">
    <v-flex xs12 sm6 v-for="(page) in pages" :key="page.id">
      <PageInNavigation
        :page="page"
        :shareToken="false"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      page: state => state.pages.page,
    }),
    pages () {
      return this.page.pageSpecific.relatedPages.map((relatedPage) => {
        return relatedPage.page
      })
    },
  },
  components: {
    PageInNavigation: () =>
      import('@/components/view-components/webapp-pages/PageInNavigation.vue'),
  },
}
</script>
<style lang="scss">
.section-max-width {
  max-width: 700px;
}

.dashboard-buttons {
  align-items: stretch;
  padding: 20px;
  .flex {
    padding: 10px 0 10px 0;
  }
}
@media (min-width: 600px) {
  .dashboard-buttons {
    .flex {
      padding: 10px;
    }
  }
}
</style>